import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'versionLabel' })
export class VersionLabelPipe implements PipeTransform {
  transform(version: number | null | undefined): string {
    if (version === null || version === undefined) return '';
    return version > 9 ? `V-${version}` : `V-0${version}`;
  }
}
